<template>
    <swiper :options="swiperOption">
      <swiper-slide><img id="8" src="../../static/img/home_fz.png" alt=""></swiper-slide>
      <swiper-slide><img id="1" src="../../static/img/home_lhb.png" alt=""></swiper-slide>
      <swiper-slide><img id="4" src="../../static/img/home_lcb.png" alt=""></swiper-slide>
      <swiper-slide><img id="3" src="../../static/img/home_zzb.png" alt=""></swiper-slide>
      <swiper-slide><img id="2" src="../../static/img/home_xebx.png" alt=""></swiper-slide>
      <swiper-slide><img id="0" src="../../static/img/home_rb.png" alt=""></swiper-slide>
      <swiper-slide><img id="5" src="../../static/img/home_thb.png" alt=""></swiper-slide>
      <div class="swiper-button-prev" slot="button-prev" style="top: 40%"></div>
      <div class="swiper-button-next" slot="button-next" style="top: 40%"></div>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data () {
    let vm = this
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        autoplayStopOnLast: true,
        loop: true,
        autoplay: true,
        delay: 16,
        controller: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          click (e) {
            let page = 3
            let id = e.target.id
            if (id) {
              vm.$router.push({path: '/cpfz', query: {page: page, id: id}})
            }
          }
        }
      }
    }
  }
}
</script>

<style>
.swiper-pagination {
    position: relative;
    top: -20px;
    color: #fff;
    z-index: 15;
    height: 50px;
}
.swiper-container {
    height: 455px;
     cursor: pointer;
     /* position: relative; */
}
</style>



// WEBPACK FOOTER //
// src/components/Swiper.vue